import { IUpsertWorkspaceImageRequest } from "api/models/request/IUpsertWorkspaceImageRequest";
import { convertFileToBase64 } from "helpers/fileHelper";

export const toUpsertWorkspaceImageRequest = async (file: File): Promise<IUpsertWorkspaceImageRequest> => {
    const base64 = await convertFileToBase64(file);
    if (typeof base64 !== "string") {
        throw new Error("workspaceManagement.logo.saveError");
    }

    return {
        fileBytes: base64.split(",")[1],
        fileExtension: file.name.split(".").pop()!.toLowerCase(),
    };
};
